import {Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CentroLogistico } from 'src/app/_models/CentroLogistico';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'popup-centro-logistico',
  templateUrl: './popup-centro-logistico.component.html',
  styleUrls: ['./popup-centro-logistico.component.css']
})
export class PopupCentroLogisticoComponent implements OnInit {

    public centrosLogisticos: CentroLogistico[];
    public centroLogisticoSelecionado: CentroLogistico;

    displayedColumns: string[] = ['codigoCentroLogistico','descricao', 'enderecoCompleto'];
    dataSource = new MatTableDataSource<CentroLogistico>();
    selection = new SelectionModel<CentroLogistico>(true, []);

    @ViewChild(MatSort, {static: true}) sort: MatSort;
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

    constructor(private dialogRef: MatDialogRef<PopupCentroLogisticoComponent>,
        @Inject(MAT_DIALOG_DATA) data) {

        this.centrosLogisticos = data.centrosLogisticos;
    }

    ngOnInit() {
        this.dataSource = new MatTableDataSource<CentroLogistico>(this.centrosLogisticos);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    selectRow(row) {
        this.centroLogisticoSelecionado = row;
        this.dialogRef.close(this.centroLogisticoSelecionado);
    }

    closePopup(){
        this.dialogRef.close("");
    }

    applyFilter(filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
}
